/* tslint:disable */
/* eslint-disable */
/**
 * ETL-API
 * Token gönderimi \"Authorization: Bearer {token}\" headeri ile veya \"access_token\" query parametresi ile yapılabilir
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import dayjs from "utils/dayjs";
/**
 * 
 * @export
 * @interface UserWithTokenDTO
 */
export interface UserWithTokenDTO {
    /**
     * 
     * @type {string}
     * @memberof UserWithTokenDTO
     */
    token?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UserWithTokenDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof UserWithTokenDTO
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserWithTokenDTO
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserWithTokenDTO
     */
    surname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserWithTokenDTO
     */
    fullName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UserWithTokenDTO
     */
    tenantId?: number;
    /**
     * 
     * @type {string}
     * @memberof UserWithTokenDTO
     */
    timeZone?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof UserWithTokenDTO
     */
    timeZoneOffset?: dayjs.Dayjs;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserWithTokenDTO
     */
    grantedPermissions?: Array<string> | null;
    /**
     * 
     * @type {number}
     * @memberof UserWithTokenDTO
     */
    personelId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UserWithTokenDTO
     */
    driverId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UserWithTokenDTO
     */
    personelPersonelDeparmentId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UserWithTokenDTO
     */
    userImg?: string | null;
}

/**
 * Check if a given object implements the UserWithTokenDTO interface.
 */
export function instanceOfUserWithTokenDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UserWithTokenDTOFromJSON(json: any): UserWithTokenDTO {
    return UserWithTokenDTOFromJSONTyped(json, false);
}

export function UserWithTokenDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserWithTokenDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'token': !exists(json, 'token') ? undefined : json['token'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'surname': !exists(json, 'surname') ? undefined : json['surname'],
        'fullName': !exists(json, 'fullName') ? undefined : json['fullName'],
        'tenantId': !exists(json, 'tenantId') ? undefined : json['tenantId'],
        'timeZone': !exists(json, 'timeZone') ? undefined : json['timeZone'],
        'timeZoneOffset': !exists(json, 'timeZoneOffset') ? undefined : (dayjs.utc(json['timeZoneOffset'], "HH:mm:ss").local()),

        'grantedPermissions': !exists(json, 'grantedPermissions') ? undefined : json['grantedPermissions'],
        'personelId': !exists(json, 'personelId') ? undefined : json['personelId'],
        'driverId': !exists(json, 'driverId') ? undefined : json['driverId'],
        'personelPersonelDeparmentId': !exists(json, 'personelPersonelDeparmentId') ? undefined : json['personelPersonelDeparmentId'],
        'userImg': !exists(json, 'userImg') ? undefined : json['userImg'],
    };
}

export function UserWithTokenDTOToJSON(value?: UserWithTokenDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'token': value.token,
        'id': value.id,
        'email': value.email,
        'name': value.name,
        'surname': value.surname,
        'fullName': value.fullName,
        'tenantId': value.tenantId,
        'timeZone': value.timeZone,
        'timeZoneOffset': value.timeZoneOffset === undefined ? undefined : (value.timeZoneOffset.toISOString()),
        'grantedPermissions': value.grantedPermissions,
        'personelId': value.personelId,
        'driverId': value.driverId,
        'personelPersonelDeparmentId': value.personelPersonelDeparmentId,
        'userImg': value.userImg,
    };
}

